export default "https://cdn-static.gokick.com/assets/ecb6814e4f4fd856ee5e2a82e5f087b2e6d90ad2/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";